import React from "react";
import { Card, CardBody, CardTitle, CardSubtitle } from "reactstrap";
import { numberWithCommas } from "../../../utils/func";

/**
 * Komponen KPI Card untuk menampilkan statistik utama
 * @param {string} title - Judul card
 * @param {string|number} value - Nilai yang ditampilkan
 * @param {string} subtitle - Subtitle/deskripsi
 * @param {string} icon - Icon class (eva-icons atau font-awesome)
 * @param {string} color - Warna card (primary, success, warning, danger, info)
 * @param {string} format - Format nilai (number, currency, percentage)
 */
export default function KPICard({
  title,
  value,
  subtitle,
  icon,
  color = "primary",
  format = "number",
}) {
  const formatValue = (val) => {
    if (format === "currency") {
      return `Rp ${numberWithCommas(val)}`;
    } else if (format === "percentage") {
      return `${val}%`;
    } else {
      return numberWithCommas(val);
    }
  };

  const colorClasses = {
    primary: "bg-primary text-white",
    success: "bg-success text-white",
    warning: "bg-warning text-white",
    danger: "bg-danger text-white",
    info: "bg-info text-white",
  };

  return (
    <Card className={`h-100 border-0 shadow-sm ${colorClasses[color]}`}>
      <CardBody className="p-4 d-flex flex-column justify-content-between">
        <div>
          <CardSubtitle className="text-white-50 text-uppercase mb-2" tag="h6">
            {title}
          </CardSubtitle>
          <CardTitle tag="h2" className="mb-2 fw-bold">
            {formatValue(value)}
          </CardTitle>
          {subtitle && (
            <small className="text-white-50 d-block">{subtitle}</small>
          )}
        </div>
        {icon && (
          <div className="align-self-end display-6 text-white-50">
            <i className={icon} />
          </div>
        )}
      </CardBody>
    </Card>
  );
}
